import { useEffect, useState } from 'react'

const useBreakpoint = (breakpoint = 768, delay = 75) => {
  const [bigger, setBigger] = useState(window.innerWidth > breakpoint)
  useEffect(() => {
    const resize = debounce(() => {
      setBigger(window.innerWidth > breakpoint)
    }, delay)
    window.addEventListener('resize', resize)
    return () => window.removeEventListener('resize', resize)
  }, [breakpoint, delay])
  return bigger
}

export function debounce(fn, delay) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn(...args)
    }, delay)
  }
}

export default useBreakpoint
